import IAppStore from "app/IAppStore";
import { MerchantFeature } from "domain/merchant";
import { localizeCommon } from "features/localization/localizeService";
import useMerchantFeature from "features/merchants/useMerchantFeature";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export function useCustomerWillSellText() {
    const purchaseSaleEnabled = useMerchantFeature(
        MerchantFeature.PurchaseSaleTerminology,
    );
    const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);
    const location = useLocation();
    const isAdminApp =
        location.pathname === "/admin" || location.pathname.startsWith("/admin/");
    const shouldUsePurchaseSaleTerminology =
        purchaseSaleEnabled && !isCustomer && !isAdminApp;

    return useMemo(
        () => ({
            formatValue(value: boolean | null | undefined) {
                if (value == null) return "";
                if (shouldUsePurchaseSaleTerminology) {
                    return value
                        ? localizeCommon("CustomerWillSell_Purchase")
                        : localizeCommon("CustomerWillSell_Sale");
                } else {
                    return value
                        ? localizeCommon("CustomerWillSell_Sell")
                        : localizeCommon("CustomerWillSell_Buy");
                }
            },
            label: shouldUsePurchaseSaleTerminology
                ? localizeCommon("CustomerWillSell_PurchaseSale")
                : localizeCommon("CustomerWillSell_CustomerWill"),
            values: shouldUsePurchaseSaleTerminology
                ? localizeCommon("CustomerWillSell_PurchaseSale")
                : localizeCommon("CustomerWillSell_BuySell"),
            columnHeader: shouldUsePurchaseSaleTerminology
                ? localizeCommon("CustomerWillSell_PurchaseSale_Short")
                : localizeCommon("CustomerWillSell_BuySell_Short"),
            columnDescription: shouldUsePurchaseSaleTerminology
                ? localizeCommon("CustomerWillSell_PurchaseSale")
                : localizeCommon("CustomerWillSell_BuySell"),
            shouldUsePurchaseSaleTerminology,
        }),
        [shouldUsePurchaseSaleTerminology],
    );
}

export type CustomerWillSellText = ReturnType<typeof useCustomerWillSellText>;
